module.exports = __webpack_public_path__ + "static/media/h.cd736b5a.jpg";